import React from 'react';
import { EmployeeRole, SiteRole } from 'types';
import { RoleActions } from './roleActions';

const addDebitLanguage = "While you're waiting, be sure to enter your debit card if you wish to receive payments.";

export const messagingRequiresAction = (messageRole?: EmployeeRole | SiteRole, messageEntity?: string, isMultiInvite?: boolean) => {
  if (isMultiInvite) {
    return <span data-cy="messaging-requires-action-multi">{`Your account will now be reviewed by your manager. Once approved you will be able to access your new roles. ${addDebitLanguage}`}</span>;
  }
  if (messageRole === EmployeeRole.EMPLOYEE) {
    return (
      <span data-cy="messaging-requires-action-employee">
        {`Your account will now be reviewed by your manager. Once approved you will be able to ${RoleActions.EMPLOYEE} from `} <strong>{messageEntity}</strong>
        {'. '}
        {addDebitLanguage}
      </span>
    );
  }
  if (messageRole === EmployeeRole.MANAGER) {
    return (
      <span data-cy="messaging-requires-action-manager">
        {`Your account will now be reviewed by your manager. Once approved you will be able to ${RoleActions.MANAGER} at `} <strong>{messageEntity}</strong>
        {'. '}
        {addDebitLanguage}
      </span>
    );
  }
  if (messageRole === EmployeeRole.SITE_ADMIN) {
    return (
      <span data-cy="messaging-requires-action-siteadmin">
        {`Your account will now be reviewed by your manager. Once approved you will be able to ${RoleActions.SITE_ADMIN} at `} <strong>{messageEntity}</strong>
        {'. '}
        {addDebitLanguage}
      </span>
    );
  }
  if (messageRole === EmployeeRole.ADMIN) {
    return (
      <span data-cy="messaging-requires-action-admin">
        {`Your account will now be reviewed by your manager. Once approved you will be able to ${RoleActions.ADMIN} at `} <strong>{messageEntity}</strong>
        {'. '}
        {addDebitLanguage}
      </span>
    );
  }
  return null;
};
